var _path, _path2, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZimbabwe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 19,
    width: 22,
    viewBox: "0 0 800 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006400"
    },
    d: "M0 0h252v126H0z",
    transform: "scale(3.1746)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd200"
    },
    d: "M0 18h252v90H0z",
    transform: "scale(3.1746)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d40000"
    },
    d: "M0 36h252v54H0z",
    transform: "scale(3.1746)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 171.428h800v57.143H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.55 0 266.666 200L14.549 400H0V0h14.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 84 63-84 63",
    style: {
      fill: "#fff"
    },
    transform: "scale(3.1746)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(85.4608 0 0 89.85934 101.448 189.301)",
    style: {
      fill: "#d40000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#d40000"
    },
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(18 3.157 -.5)",
    style: {
      fill: "#d40000"
    },
    id: "a",
    d: "M0 0v1h.5z"
  }), /*#__PURE__*/React.createElement("use", {
    width: 900,
    height: 600,
    transform: "scale(-1 1)",
    xlinkHref: "#a",
    style: {
      fill: "#d40000"
    }
  })), /*#__PURE__*/React.createElement("use", {
    width: 900,
    height: 600,
    transform: "rotate(72.001)",
    xlinkHref: "#b",
    style: {
      fill: "#d40000"
    }
  }), /*#__PURE__*/React.createElement("use", {
    width: 900,
    height: 600,
    transform: "rotate(-72.001)",
    xlinkHref: "#b",
    style: {
      fill: "#d40000"
    }
  }), /*#__PURE__*/React.createElement("use", {
    width: 900,
    height: 600,
    transform: "rotate(144)",
    xlinkHref: "#b",
    style: {
      fill: "#d40000"
    }
  }), /*#__PURE__*/React.createElement("use", {
    width: 900,
    height: 600,
    transform: "rotate(-144)",
    xlinkHref: "#b",
    style: {
      fill: "#d40000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.895 131.394) scale(.10914)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0
    },
    d: "M10.602 526.28V29.655H727.31v993.252H10.602V526.281z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M537.16 973.475c.154-78.618 14.545-153.42 44.896-233.369 13.808-36.37 50.082-110.25 59.704-121.598.952-1.122 16.418 1.762 34.37 6.409 36.727 9.506 46.756 7.756 46.756-8.156 0-9.11-37.543-40.366-221.115-184.08-123.692-96.836-225.115-173.107-230.193-173.107-4.993 0-9.972-2.587-11.064-5.748-1.092-3.161-7.03-40.676-13.197-83.365-6.166-42.69-14.48-84.777-18.476-93.528-11.681-25.586-35.8-39.098-74.382-41.672-29.206-1.948-35.32-.85-55.092 9.896-13.387 7.276-29.397 12.088-40.22 12.088-21.998 0-39.697 15.862-39.697 35.578v13.005l32.075-.902c91.927 3.075 8.029 11.519 1.337 12.733-22.822 4.14 4.966 22.797 31.81 31.785 28.886 9.67 27.685 4.002 27.685 130.666 0 104-.914 118.736-8.848 142.707-11.648 35.188-11.648 87.441 0 121.857 4.707 13.91 8.624 26.864 8.704 28.786.079 1.922-13.626 18.93-30.457 37.797C51.36 645.331 32.723 681.9 32.723 707.47c0 5.887-3.982 15.964-8.848 22.395-11.227 14.834-11.571 40.262-.677 49.958C34.5 789.88 81.224 970 81.348 1003.989c.045 12.394 2.156 12.338 73.038-1.944 57.224-11.53 192.543-14.002 261.024-4.768 31.632 4.265 68.463 10.566 81.846 14.002 42.15 10.822 39.805 13.043 39.905-37.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      fillOpacity: 1
    },
    d: "M479.56 999.39c-62.407-14.03-132.93-19.384-212.359-16.12-40.149 1.65-82.22 4.67-93.493 6.713l-20.495 3.712-5.084-31.998c-2.796-17.6-4.45-32.658-3.674-33.464.776-.806 20.25-4.01 43.276-7.12 79.05-10.675 248.017-6.447 326.115 8.16l14.379 2.69v38.575c0 28.132-1.497 38.403-5.53 37.94-3.042-.348-22.453-4.438-43.136-9.088zm-389.324 2.898c0-9.261-24.61-119.73-35.356-158.708-7.32-26.55-13.309-49.999-13.309-52.107 0-2.109 6.705.473 14.9 5.738 8.196 5.264 18.648 9.618 23.227 9.674 22.796.28 35.278 32.315 54.607 140.149 2.72 15.175 5.859 32.075 6.976 37.557 1.78 8.736-.73 10.582-20.3 14.945-24.74 5.514-30.745 6.052-30.745 2.752zm431.707-84.548c-1.358-2.284.495-6.71 4.118-9.835 5.356-4.62 6.588-4.338 6.588 1.507 0 8.585-7.216 14.198-10.706 8.328zm-355.458-17.56c11.758-12.221 12.008-12.264 21.203-3.615 8.77 8.25 8.844 8.941 1.274 12.043-4.417 1.81-13.958 3.437-21.203 3.615l-13.172.323 11.898-12.367zm291.934 7.011c.944-2.945 5.59-7.974 10.323-11.176 7.454-5.044 9.668-4.328 16.554 5.354l7.949 11.177h-18.272c-11.935 0-17.676-1.857-16.554-5.355zm39.308-6.562c-5.194-6.864-8.792-13.156-7.996-13.983.796-.828 9.944.006 20.329 1.851l18.881 3.356-10.885 10.627-10.885 10.627-9.444-12.478zm-361.567.646c-3.248-8.8 4.48-16.134 17.12-16.25 10.056-.09 9.825.892-3.202 13.613-9.988 9.753-11.205 9.983-13.917 2.637zm103.328-8.269 11.666-12.642 11.342 10.343c6.238 5.689 11.979 10.66 12.758 11.048.778.388-9.575 1.423-23.008 2.3l-24.424 1.593 11.666-12.642zm156.717 10.887-14.781-2.843 10.638-10.343 10.638-10.343 12.713 13.792c13.907 15.088 12.449 15.827-19.208 9.737zm-195.365-12.04-10.391-11.496h15.894c8.741 0 19.346-1.377 23.565-3.06 6.188-2.468 5.67-.245-2.682 11.496-5.695 8.006-11.623 14.556-13.175 14.556-1.551 0-7.497-5.173-13.211-11.496zm112.832-2.318 12.733-13.814 12.427 12.375c6.835 6.807 12.428 13.023 12.428 13.814 0 .792-11.322 1.44-25.16 1.44h-25.161l12.733-13.815zm117.222 2.318-10.39-11.496h20.68c22.342 0 25.212 3.507 12.588 15.382-10.38 9.764-10.57 9.731-22.878-3.886zm-154.844-4.598-10.391-11.496h47.326l-10.39 11.496c-12.83 14.194-13.716 14.194-26.545 0zm79.634 0-10.39-11.496h47.325l-10.39 11.496c-12.83 14.194-13.716 14.194-26.545 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      fillOpacity: 1
    },
    d: "M497.256 875.63c-10.95-1.967-54.947-6.181-97.773-9.366-74.332-5.528-166.33-2.57-248.415 7.988-16.944 2.18-21.014 1.357-21.014-4.244 0-11.857 88.713-19.54 225.63-19.54 66.915 0 135.102 1.716 151.526 3.814 27.632 3.53 29.863 4.647 29.863 14.945 0 12.266-3.787 12.875-39.817 6.403zm-344.041-39.17c9.09-8.735 18.199-15.882 20.244-15.882 2.044 0 8.25 5.015 13.79 11.144l10.072 11.143-21.467 2.891c-11.807 1.59-25.45 3.723-30.316 4.74-6.575 1.372-4.602-2.234 7.677-14.036zm-31.33 2.102c-3.28-9.124-2.36-11.732 5.202-14.733 5.054-2.005 12.921-3.04 17.484-2.299 7.249 1.177 6.592 3.038-5.202 14.733l-13.498 13.385-3.986-11.086zm410.764 5.5c0-2.259 2.885-5.257 6.41-6.663 4.286-1.71 5.596-.348 3.951 4.106-2.685 7.273-10.361 9.168-10.361 2.557zm-297.307-16.563c6.573-7.575 11.952-14.13 11.954-14.565.002-.436 6.314 5.069 14.028 12.232l14.025 13.025-25.979 1.54-25.98 1.54 11.952-13.772zm236.44 12.702-18.838-1.762 13.52-11.824 13.52-11.824 10.848 10.593c11.83 11.552 14 18.644 5.318 17.383-3.042-.442-14.007-1.597-24.368-2.566zm-273.637-12.749-12.753-10.57 21.2-3.304c11.66-1.818 21.935-2.538 22.832-1.601.898.937-2.904 7.18-8.447 13.874L210.9 838.02l-12.754-10.57zm193.701 7.594-10.292-3.01 11.268-11.002c9.542-9.317 12.341-10.077 18.275-4.958 3.854 3.325 8.96 9.836 11.346 14.47 3.74 7.265 2.64 8.362-7.984 7.967-6.777-.252-16.953-1.812-22.613-3.467zm111.768-10.526-12.994-14.45 11.06 2.892c6.083 1.59 19.024 2.93 28.757 2.978l17.696.085-13.272 11.308c-7.3 6.22-14.393 11.382-15.763 11.473-1.37.091-8.338-6.337-15.484-14.286zm-226.954-.967c-5.202-5.756-9.459-11.884-9.459-13.618s11.259-3.152 25.019-3.152h25.018l-8.378 9.622c-14.82 17.02-21.863 18.584-32.2 7.148zm40.8-1.036c14.257-13.032 19.175-12.727 28.43 1.762 6.374 9.977 6.173 10.092-17.317 9.949l-23.767-.145 12.653-11.566zm109.78-2.193-10.291-13.541h10.843c5.964 0 16.95 1.27 24.413 2.82l13.568 2.821-12.548 10.975c-6.901 6.036-13.256 10.86-14.121 10.72-.866-.14-6.205-6.348-11.865-13.795zm-71.556-2.045-10.39-11.496h47.325l-10.39 11.496c-12.83 14.194-13.716 14.194-26.545 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      fillOpacity: 1
    },
    d: "M119.117 803.334c1.806-4.426 5.634-18.394 8.508-31.04l5.225-22.991 48.567-25.291c26.712-13.91 56.443-31.67 66.07-39.465 9.626-7.795 19.751-15.523 22.5-17.173 6.88-4.13 135.18 4.716 191.876 13.23 43.661 6.557 120.253 20.717 122.832 22.71.644.496-6.045 21.393-14.863 46.438-8.818 25.044-16.833 48.353-17.81 51.797-1.335 4.7-6.73 5.49-21.62 3.17-72.704-11.333-282.167-10.277-362.743 1.828-45.806 6.88-52.48 6.44-48.542-3.213z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1
    },
    d: "M488.748 774.948c28.498-29.62 8.999-78.527-31.31-78.527-25.87 0-44.24 19.095-44.24 45.984 0 41.896 47.052 62.163 75.55 32.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      fillOpacity: 1
    },
    d: "M441.163 773.904c-24.075-12.542-22.365-52.766 2.703-63.558 24.21-10.424 48.966 6.044 48.966 32.573 0 25.228-29.158 42.713-51.669 30.985z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    height: 1052.362,
    width: 744.094,
    transform: "translate(-175.132 -5.24)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      fillOpacity: 1
    },
    d: "M99.194 790.39c6.22-17.007 5.414-38.788-1.437-38.788-3.623 0-5.75 5.954-5.75 16.094 0 8.852-2.643 18.681-5.871 21.843-4.852 4.751-5.445 1.163-3.417-20.693 1.35-14.542.761-26.44-1.307-26.44-3.97 0-11.667 22.026-14.464 41.385-1.64 11.35-1.707 11.325-5.37-2.061-2.86-10.454-1.524-17.504 5.838-30.8 5.251-9.485 9.548-23.368 9.548-30.852 0-11.274 8.44-22.156 49.218-63.466 27.07-27.423 58.579-61.434 70.019-75.58 19.795-24.479 20.764-26.98 20.052-51.775-.411-14.33-2.001-27.356-3.533-28.948-5.17-5.374-12.098 22.39-9.365 37.532 2.47 13.69-.073 18.309-28.626 51.988-17.235 20.33-46.432 51.078-64.881 68.33-33.984 31.777-46.156 48.95-46.156 65.122 0 4.908-3.846 17.852-8.547 28.765-4.7 10.913-7.395 22.003-5.987 24.644 1.576 2.956.54 2.874-2.694-.214-3.83-3.657-4.081-10.442-.925-25.044 2.382-11.015 3.32-21.725 2.087-23.799-4.746-7.981-10.34 2.283-13.122 24.07-1.594 12.494-4.638 21.599-6.764 20.233-6.4-4.111-4.358-26.753 3.458-38.353 4.029-5.977 9.02-20.298 11.091-31.825 5.81-32.328 19.777-57.952 50.638-92.905 15.553-17.615 28.278-32.73 28.278-33.588 0-.858-4.105-13.783-9.122-28.721-11.602-34.54-12.417-87.15-1.847-119.129 11.14-33.7 34.063-67.017 70.333-102.223 37.443-36.345 73.017-58.217 90.278-55.505 14.851 2.334 443.19 337.206 443.19 346.484 0 3.672-3.483 6.622-7.741 6.555-4.259-.066-113.185-30.893-242.06-68.505-205.955-60.107-235.542-69.864-244.433-80.607-12.635-15.269-13.18-38.61-1.267-54.351 4.867-6.43 8.848-14.422 8.848-17.76 0-10.174-21.865 15.85-26.045 30.999-4.886 17.71 4.247 47.391 17.538 56.992 5.252 3.793 44.49 17.255 87.195 29.913 72.886 21.605 77.9 23.805 81.77 35.872 9.29 28.97-21.327 62.67-65.623 72.228-14.284 3.082-32.476 11.581-45.023 21.034-49.879 37.577-84.692 59.666-113.804 72.209-17.12 7.375-33.579 15.818-36.576 18.762-2.997 2.945-7.454 16.341-9.905 29.77-5.203 28.518-7.304 32.902-15.766 32.902-4.898 0-5.323-2.575-1.95-11.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fc0",
      fillOpacity: 1
    },
    d: "M548.133 684.53c-45.513-10.453-117.51-20.411-190.68-26.375l-70.343-5.733 26.545-10.059c14.6-5.532 35.58-15.046 46.623-21.14 17.326-9.563 24.301-10.772 50.878-8.816 39.46 2.905 66.057-4.374 75.924-20.78 4.124-6.855 8.043-13.267 8.71-14.248.666-.981 32.003 7.078 69.637 17.908l68.425 19.693-13.261 23.477c-7.294 12.912-16.497 30.202-20.452 38.421-8.03 16.689-10.852 17.104-52.006 7.652zM120.174 339.402c-1.242-19.879-1.242-66.266 0-103.083 2.565-76.092.58-83.582-24.373-91.936-20.37-6.82-46.965-14.158-39.114-18.823 8.572-5.092 16.507-1.51 38.291-6.928 7.715-1.92 7.395-1.619 6.153-8.207-2.237-11.868-13.908-17.216-46.718-15.447-25.767 1.39-28.956.653-27.21-6.286 3.53-14.026 17.978-23.294 39.627-25.418 11.657-1.143 28.807-6.29 38.112-11.437 13.73-7.595 23.066-9.036 49.547-7.646 57.954 3.042 68.923 18.951 84.11 121.984 5.894 39.988 10.76 77.074 10.811 82.412.068 6.936-8.02 15.162-28.342 28.82-29.923 20.115-68.605 56.694-87.44 82.688l-11.197 15.45-2.257-36.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.323221,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.80954 0 0 .76957 11.8 5.87)",
    d: "M174.286 95.22a18.571 20 0 1 1-37.143 0 18.571 20 0 1 1 37.143 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.32499999,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.57411 0 0 2.32782 -116.696 -125.753)",
    d: "M167.857 88.076a6.429 4.286 0 1 1-12.857 0 6.429 4.286 0 1 1 12.857 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-3.571 -2.857)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(18.214)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(41.071 4.286)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(61.786 8.571)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(6.786 13.571)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(66.071 29.286)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(41.786 30.714)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(16.786 29.286)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-4.643 30)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(49.643 19.286)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(28.214 17.143)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(6.071 41.429)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(28.929 42.143)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(53.214 42.857)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-15.357 41.071)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.25511801,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(73.571 18.929)",
    d: "M410.714 558.076a7.5 5 0 1 1-15 0 7.5 5 0 1 1 15 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwe);
export default __webpack_public_path__ + "static/media/zimbabwe.1cd9b6090021bd387c6d29f317c9ffce.svg";
export { ForwardRef as ReactComponent };